export default "/images/vendor/flag-icon-css/flags/1x1/ae.svg?23c174705b39d649ba4341c8f1c83aac";